import get from "lodash/get";
import React from "react";
import { useCookies } from "react-cookie";
import Helmet from "react-helmet";
import { buildUserProperties } from "../../lib/gtm/utils";
import { dataLayer, buildGtmData } from "../../lib/googleTagManager";

export const withDatalayer = (Component) => (props) => {
  const userInfo = get(props, "userInfo", {});
  const userInfoLoading = get(props, "userInfoLoading", {});
  const userAccount = get(props, "userAccount", {});
  const rbVisitorID = get(props, "rbVisitorID");

  const [cookies] = useCookies(["_ga"]);

  const gtmDataLayer = userInfo ? buildGtmData(userInfo, cookies) : {};

  const gtmUserProperties = buildUserProperties({
    userInfo,
    cookies,
    userAccount,
    rbVisitorID,
  });

  return (
    <>
      <Helmet>
        {gtmDataLayer && gtmDataLayer.visitorType && !userInfoLoading && (
          <script>{dataLayer(gtmDataLayer, gtmUserProperties)}</script>
        )}
      </Helmet>
      <Component {...props} />;
    </>
  );
};
